import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "form-item-content" }
const _hoisted_3 = { class: "form-item-content" }
const _hoisted_4 = { class: "form-item-content" }
const _hoisted_5 = { class: "form-item-content" }
const _hoisted_6 = { class: "form-item-content" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { key: 6 }
const _hoisted_12 = { key: 7 }

import { onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { User } from "@/api/models/user/User";
import { UserUpdateRequest } from "@/api/models/user/UserUpdateRequest";
import { UserService } from "@/api/services/UserService";
import { UserListRequest } from "@/api/models/user/UserListRequest";
import { ToImage } from "@/utils/image";
import FileUpload from "@/components/FileUpload.vue";
import { Moment } from "moment";


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminUser',
  setup(__props) {

dayjs.locale("zh-cn");

const total = ref<number>(0);

const listRequest = reactive<UserListRequest>({
  current: 1,
  size: 20,
  content: "",
  start_time: 0,
  end_time: 0,
});

const userList = ref<User[]>([{}]);

const handleList = async () => {
  const res = await UserService.ListAll(listRequest);
  if (res.code === 0) {
    userList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

const resetSearch = () => {
  listRequest.current = 1;
  listRequest.size = 20;
  listRequest.content = "";
  listRequest.start_time = 0;
  listRequest.end_time = 0;
  handleList();
};

onMounted(async () => {
  await handleList();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const openUpdate = ref(false);
const openRecharge = ref(false);

const updateRequest = reactive<UserUpdateRequest>({
  id: 0,
  name: "",
  balance: 0.0,
  status: 0,
  avatar: "",
  leave_time: 0,
  come_time: 0,
  is_delete: 1,
});

const levelTimeChange = (_: Moment, mode: string) => {
  updateRequest.leave_time = Date.parse(mode);
};

const comeTimeChange = (_: Moment, mode: string) => {
  updateRequest.come_time = Date.parse(mode);
};

const createAtChange = (_: Moment, mode: string) => {
  listRequest.start_time = Date.parse(mode);
};

const updateAtChange = (_: Moment, mode: string) => {
  listRequest.end_time = Date.parse(mode);
};

const handleUpdate = (record: User) => {
  openUpdate.value = true;
  Object.assign(updateRequest, record);
  updateRequest.leave_time = Date.parse(record.leave_time);
  updateRequest.come_time = Date.parse(record.come_time);
};

const submitUpdate = async () => {
  const res = await UserService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const rechargeSubmit = async () => {
  const res = await UserService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const rechargeUpdate = async (record: User) => {
  openRecharge.value = true;
  Object.assign(updateRequest, record);
  updateRequest.balance = record.balance;
  updateRequest.leave_time = Date.parse(record.leave_time);
  updateRequest.come_time = Date.parse(record.come_time);
};

const submitDelete = async (record: User) => {
  const res = await UserService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: User) => {
  const res = await UserService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "OpenId",
    dataIndex: "open_id",
    align: "center",
  },
  {
    title: "头像",
    dataIndex: "avatar",
    align: "center",
  },
  {
    title: "用户名",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "余额",
    dataIndex: "balance",
    align: "center",
  },
  // {
  //   title: "可用状态",
  //   dataIndex: "status",
  //   align: "center",
  // },
  {
    title: "离家时间",
    dataIndex: "leave_time",
    align: "center",
  },
  {
    title: "回家时间",
    dataIndex: "come_time",
    align: "center",
  },
  // {
  //   title: "来源",
  //   dataIndex: "origin",
  //   align: "center",
  // },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "修改时间",
    dataIndex: "update_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
    width: 300,
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        model: handleList,
        class: "search-form",
        onSubmit: handleList
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { name: "status" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "label" }, "会员状态：", -1)),
                _createVNode(_component_a_select, {
                  style: {"width":"100px"},
                  value: listRequest.status,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((listRequest.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("可用")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode("禁用")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { name: "origin" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "label" }, "会员来源：", -1)),
                _createVNode(_component_a_select, {
                  style: {"width":"150px"},
                  value: listRequest.origin,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((listRequest.origin) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode("微信小程序")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { name: "content" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "label" }, "搜索内容：", -1)),
                _createVNode(_component_a_input, {
                  placeholder: "OpenId/用户名/电话号码",
                  value: listRequest.content,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((listRequest.content) = $event))
                }, null, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { name: "create_at" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "label" }, "创建时间：", -1)),
                _createVNode(_component_a_date_picker, {
                  placeholder: "选择时间",
                  format: "YYYY-MM-DD HH:mm:ss",
                  "show-time": { defaultValue: _unref(dayjs)('00:00:00', 'HH:mm:ss') },
                  onChange: createAtChange
                }, null, 8, ["show-time"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { name: "update_at" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "label" }, "修改时间：", -1)),
                _createVNode(_component_a_date_picker, {
                  placeholder: "选择时间",
                  format: "YYYY-MM-DD HH:mm:ss",
                  "show-time": { defaultValue: _unref(dayjs)('00:00:00', 'HH:mm:ss') },
                  onChange: updateAtChange
                }, null, 8, ["show-time"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit"
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createTextVNode("搜索")
                ])),
                _: 1
              }),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                onClick: resetSearch
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createTextVNode("重置")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_a_table, {
        columns: columns,
        "data-source": userList.value,
        pagination: {
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total.value,
        defaultPageSize: listRequest.size,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      },
        scroll: { x: 1000, y: 800 },
        bordered: ""
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.dataIndex === 'is_delete')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (record.is_delete === 1)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 0,
                      color: "green"
                    }, {
                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                        _createTextVNode("正常")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (record.is_delete === 2)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 1,
                      color: "red"
                    }, {
                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                        _createTextVNode("回收站")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : (column.dataIndex === 'status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (record.status === 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "green"
                      }, {
                        default: _withCtx(() => _cache[22] || (_cache[22] = [
                          _createTextVNode("可用")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.status === 2)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "red"
                      }, {
                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                          _createTextVNode("禁用")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : (column.dataIndex === 'avatar')
                ? (_openBlock(), _createBlock(_component_a_image, {
                    key: 2,
                    src: _unref(ToImage)(record.avatar),
                    style: {"height":"60px","width":"auto"}
                  }, null, 8, ["src"]))
                : (column.dataIndex === 'origin')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      (record.status === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "微信小程序"))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (column.dataIndex === 'leave_time')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(dayjs)(record.leave_time).format("YYYY-MM-DD HH:mm:ss")), 1))
                    : (column.dataIndex === 'come_time')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(dayjs)(record.come_time).format("YYYY-MM-DD HH:mm:ss")), 1))
                      : (column.dataIndex === 'create_at')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(dayjs)(record.create_at).format("YYYY-MM-DD HH:mm:ss")), 1))
                        : (column.dataIndex === 'update_at')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(dayjs)(record.update_at).format("YYYY-MM-DD HH:mm:ss")), 1))
                          : (column.dataIndex === 'operator')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                _createVNode(_component_a_button, {
                                  onClick: ($event: any) => (handleUpdate(record)),
                                  type: "primary",
                                  style: { marginRight: '8px' }
                                }, {
                                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                                    _createTextVNode("编辑 ")
                                  ])),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_a_button, {
                                  onClick: ($event: any) => (submitDrop(record)),
                                  type: "primary",
                                  style: {
              backgroundColor: '#ff4d4f',
              color: 'white',
            }
                                }, {
                                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                                    _createTextVNode("彻底删除 ")
                                  ])),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_a_button, {
                                  onClick: ($event: any) => (rechargeUpdate(record)),
                                  type: "primary",
                                  style: {
              backgroundColor: '#ff4d4f',
              color: 'white',
            }
                                }, {
                                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                                    _createTextVNode("添加积分 ")
                                  ])),
                                  _: 2
                                }, 1032, ["onClick"])
                              ], 64))
                            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data-source", "pagination"]),
      _createVNode(_component_a_modal, {
        open: openUpdate.value,
        "onUpdate:open": _cache[7] || (_cache[7] = ($event: any) => ((openUpdate).value = $event)),
        title: "修改会员数据",
        onOk: submitUpdate,
        cancelText: "取消"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            model: updateRequest,
            style: {"margin-top":"20px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "用户名" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: updateRequest.name,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((updateRequest.name) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "离家时间" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_date_picker, {
                    placeholder: "选择时间",
                    format: "YYYY-MM-DD HH:mm:ss",
                    "show-time": { defaultValue: _unref(dayjs)('00:00:00', 'HH:mm:ss') },
                    onChange: levelTimeChange
                  }, null, 8, ["show-time"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "归家时间" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_date_picker, {
                    placeholder: "选择时间",
                    format: "YYYY-MM-DD HH:mm:ss",
                    "show-time": { defaultValue: _unref(dayjs)('00:00:00', 'HH:mm:ss') },
                    onChange: comeTimeChange
                  }, null, 8, ["show-time"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "可用状态" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: updateRequest.status,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((updateRequest.status) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: 1 }, {
                        default: _withCtx(() => _cache[27] || (_cache[27] = [
                          _createTextVNode("可用")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 2 }, {
                        default: _withCtx(() => _cache[28] || (_cache[28] = [
                          _createTextVNode("禁用")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "状态" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: updateRequest.is_delete,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((updateRequest.is_delete) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: 1 }, {
                        default: _withCtx(() => _cache[29] || (_cache[29] = [
                          _createTextVNode("正常")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 2 }, {
                        default: _withCtx(() => _cache[30] || (_cache[30] = [
                          _createTextVNode("回收站")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "用户头像" }, {
                default: _withCtx(() => [
                  _createVNode(FileUpload, {
                    modelValue: updateRequest.avatar,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((updateRequest.avatar) = $event)),
                    style: {"display":"block"}
                  }, null, 8, ["modelValue"]),
                  (updateRequest.avatar !== '')
                    ? (_openBlock(), _createBlock(_component_a_image, {
                        key: 0,
                        src: _unref(ToImage)(updateRequest.avatar),
                        style: {"max-height":"150px","display":"block","margin-top":"10px"}
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["open"]),
      _createVNode(_component_a_modal, {
        open: openRecharge.value,
        "onUpdate:open": _cache[9] || (_cache[9] = ($event: any) => ((openRecharge).value = $event)),
        title: "修改会员积分",
        onOk: rechargeSubmit,
        cancelText: "取消"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            model: rechargeUpdate,
            style: {"margin-top":"20px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "用户积分" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: updateRequest.balance,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((updateRequest.balance) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["open"])
    ])
  ], 64))
}
}

})